<template>
    <div class="chart-table-wrap px-0 pb-0">
      <div>
    <!-- <div class="pl-2">
      <v-switch v-if="dlComposition && dlComposition.length > 0 && !loading" v-model="toggleFraction" color="info"
        :label="toggleFraction ? 'Mole %' : 'Mass %'" @change="toggleFractionFunction"></v-switch>
    </div> -->
    <div class="chart-wrap">

    <v-row>
      <v-col cols="12" md="6">
        <GasCompComponentChart :data="getChartData" :loading="loading" :toggleFraction="toggleFraction" />
      </v-col>
      <v-col cols="12" md="6">
        <GasCompPressureChart :data="getChartData" :loading="loading" :toggleFraction="toggleFraction" />
      </v-col>
    </v-row>
    </div>
    <!-- <div v-if="dlComposition && dlComposition.length > 0 && !loading"> -->

    <div class="table-wrap border-0" v-if="dlComposition && dlComposition.length > 0 && !loading">
      <div class="table-title-div">
        <p class="table-title">Liberated Gas Compositions</p>
        <div class="csv-btn" @click="downloadTableCSV">
          <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
        </div>
      </div>
      <table class="data-table lib-table">
        <tr class="table-main-header main-header">
          <td>Stage Test</td>
          <td class="" v-for="component in uniqueTestStep" :key="component">
            {{ component ? component: "-"  }}
          </td>
        </tr>
        <tr class="table-sub-header sub-header">
          <td class="d-flex align-center img-td">
            <span class="mr-2">Pressure (psia) </span>
            <!-- <v-img :src="arrow_right" alt="Arrow" width="20" height="20" /> -->
          </td>
          <td class="text-left" v-for="component in uniqueStepPressure" :key="component">
            {{ component }}
          </td>
        </tr>
        <tr class="component-td">
          <td class="d-flex align-center img-td">
                <span class="mr-2">Component</span>
              </td>
          <td class="text-left" v-for="component in uniqueStepPressure" :key="component">
            {{ vaporComponentColumnLabel }}
          </td>
        </tr>
        <tbody>
          <tr  v-for="component in uniqueFluidComponents" :key="component">
            <td class="text-left">{{ component }}</td>
            <td class="text-left" v-for="(entry) in dlComposition.filter(entry => entry.fluidComponentReference === component)"
              :key="entry.stepPressure">
              {{ toggleFraction
          ? formatFraction(entry.vapor_MoleFraction)
          : formatFraction(entry.vapor_MassFraction) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Total</td>
            <td class="text-left" v-for="pressure in uniqueStepPressure" :key="pressure">
              {{ calculateSum(pressure) }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <div class="liberated-bottom-table">
        <div class="table-title-div">
          <p class="table-title">Calculated properties of Total Sample @ Standard Conditions</p>
        </div>
        <table class="data-table data-table-liberated">
          <tr class="main-header">
            <td class="main-header-td">
              <span class="mr-2">MW (g/mol)</span>
            </td>
            <td v-for="component in MW" :key="component">
              {{ component }}
            </td>
          </tr>
          <tr class="main-header">
            <td class="main-header-td">
              <span class="mr-2">Gravity (Air=1)</span>
            </td>
            <td v-for="component in Gravity" :key="component">
              {{ component }}
            </td>
          </tr>
        </table>
      </div>

      <div class="liberated-bottom-table">
        <div class="table-title-div">
          <p class="table-title">Calculated properties of C7 @ Standard Conditions</p>
        </div>
        <table class="data-table data-table-liberated">
          <tr class="main-header">
            <td class="main-header-td">
              <span class="mr-2">MW (g/mol)</span>
            </td>
            <td v-for="component in MW" :key="component">
              {{ component }}
            </td>
          </tr>
          <tr class="main-header">
            <td class="main-header-td">
              <span class="mr-2">Density (g/cc)</span>
            </td>
            <td v-for="component in Density" :key="component">
              {{ component }}
            </td>
          </tr>
        </table>
      </div> -->
    </div>
    <div v-else-if="!loading && !dlComposition" class="text-center pt-15">
      <h4>Table data is not available.</h4>
    </div>
    <div v-else-if="loading">
      <screen-loader></screen-loader>
    </div>
  </div>
  </div>
</template>

<script>
import GasCompComponentChart from "./Charts/GasCompComponentChart.vue";
import GasCompPressureChart from "./Charts/GasCompPressureChart.vue";
import ScreenLoader from "../Loaders/ScreenLoader.vue";
import axios from "axios";
import { getTenantPrefix } from "@/utils/tenant";
import { getVaporComponentCsvValueHeader } from "@/utils/chartAxisUtils";

export default {
  name: "GasCompData",
  components: {
    GasCompComponentChart,
    GasCompPressureChart,
    ScreenLoader,
  },
  data() {
    return {
      arrow_right: require("../../../assets/Images/Assets/arrow-right.png"),
      dlComposition: [],
      loading: true,
      toggleFraction: true,
      documentDownload: require("../../../assets/Images/csv.svg"),
    };
  },
  computed: {
    tenantId() {
      return getTenantPrefix() || "";
    },
    vaporComponentColumnLabel() {
      return getVaporComponentCsvValueHeader(this.toggleFraction);
    },
    uniqueTestStep() {
      if (!this.dlComposition) {
        return [];
      }

      const steps = [
        ...new Set(
          this.dlComposition.map((entry) => entry.testStep)
        ),
      ];

      const pressureLength = this.uniqueStepPressure.length;

      if (steps.length < pressureLength) {
        return [...steps, ...Array(pressureLength - steps.length).fill("-")];
      }

      return steps.slice(0, pressureLength); // Truncate if longer
    },
    uniqueFluidComponents() {
      if (!this.dlComposition) {
        return;
      }
      return [...new Set(this.dlComposition.map(entry => entry.fluidComponentReference))];
    },
    uniqueStepPressure() {
      if (!this.dlComposition) {
        return;
      }
      return [...new Set(this.dlComposition.map(entry => entry.stepPressure))];
    },
    getChartData() {
      if (!this.dlComposition) {
        return;
      }
      if (this.toggleFraction) {
        return this.dlComposition.map(entry => ({
          fluidComponentReference: entry.fluidComponentReference,
          stepPressure: entry.stepPressure,
          vapor_MoleFraction: entry.vapor_MoleFraction
        }));
      } else {
        return this.dlComposition.map(entry => ({
          fluidComponentReference: entry.fluidComponentReference,
          stepPressure: entry.stepPressure,
          vapor_MassFraction: entry.vapor_MassFraction
        }));
      }
    }
  },
  methods: {
    calculateSum(stepPressure) {
      if (!this.dlComposition) {
        return 0;
      }
      const filteredEntries = this.dlComposition.filter(
        (entry) => entry.stepPressure === stepPressure
      );
      return filteredEntries.reduce((sum, entry) => {
        return (
          sum + (parseFloat(entry.vapor_MoleFraction || 0))
        );
      }, 0).toFixed(3);
    },
    toggleFractionFunction() {
      this.dlComposition = [];
      this.getTableData();
    },
    formatFraction(value) {
    if (value === null || value === undefined) {
      return "-";
    }
    return value.toFixed(3);
  },
  async getTableData() {
  var sampleId = this.$route.params.sampleId;
  var dlId = this.$route.params.id;
  this.loading = true;
  try {
    const response = await axios.get(
      process.env.VUE_APP_API_URL +
        `public/api/samples/${sampleId}/dltests/${dlId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "X-TenantID": this.tenantId,
        },
      }
    );

    if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
      this.dlComposition = response.data.data.dltest.dlComposition;
      if (!this.dlComposition) {
        return;
      } else {
        let sortByKeys = await getSortOrder(
          "dltests",
          "dlTest",
          this.toggleFraction ? "table_for_mass" : "table_for_mole"
        );

        if (!sortByKeys || sortByKeys.length === 0) {
          sortByKeys = response.data.data.dltest.dlComposition
            .map(item => item[sortByArray])
            .flat()
            .map(key => key.charAt(0).toLowerCase() + key.slice(1));
        } else {
          sortByKeys = Object.keys(this.serverItems || {})
            .filter(key => !key.includes("_UOM"))
            .map(key => key.charAt(0).toLowerCase() + key.slice(1));
        }

        const availableKeys = new Set(
          sortByKeys.map(key => key.toLowerCase())
        );

      }
    }
  } catch (error) {
    console.error("Failed to fetch table data:", error);
  } finally {
    this.loading = false;
  }
},
    downloadTableCSV() {
      if (this.dlComposition && this.dlComposition.length > 0) {
        const fileName = `liberated_gas_compositions.csv`;

        const headerRow1 = ['Pressure (psia)', ...this.uniqueStepPressure];
        const headerRow2 = ['Component', ...this.uniqueStepPressure.map(() => this.vaporComponentColumnLabel)];

        const csvRows = this.uniqueFluidComponents.map(component => {
          const row = [component];
          this.uniqueStepPressure.forEach(pressure => {
            const entry = this.dlComposition.find(e => e.fluidComponentReference === component && e.stepPressure === pressure);
            const value = this.toggleFraction ? entry?.vapor_MoleFraction : entry?.vapor_MassFraction;
            row.push(this.formatFraction(value));
          });
          return row;
        });

        const csvContent = [
          headerRow1.join(','),
          headerRow2.join(','),
          ...csvRows.map(row => row.join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error('Your browser does not support downloading files programmatically. Please try a different browser.');
        }
      } else {
        console.error('No data available in the table to download.');
      }
    },
  },
  mounted() {
    this.getTableData();
  },
};
</script>